import { render, staticRenderFns } from "./GAlert.vue?vue&type=template&id=f3d3ca14&scoped=true&"
import script from "./GAlert.vue?vue&type=script&lang=ts&"
export * from "./GAlert.vue?vue&type=script&lang=ts&"
import style0 from "./GAlert.vue?vue&type=style&index=0&id=f3d3ca14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d3ca14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VDivider,VIcon,VRow})
